import { Loader, Provider } from '@fluentui/react-northstar';
import { app as microsoftTeamsApp } from '@microsoft/teams-js';
import { useTranslation } from 'react-i18next';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { useEffect, useState } from 'react';

import AppContext from './contexts/AppContext';
import useTheme from './hooks/UseTheme';
import './App.css';
import ConfigurationRoute from './routes/ConfigurationRoute';
import DiagramRoute from './routes/DiagramRoute';
import LoginEndRoute from './routes/LoginEndRoute';
import RedirectRoute from './routes/RedirectRoute';
import { IHopexContext } from './models/IHopexContext';

const App = () => {
  const { theme, setThemeName } = useTheme();
  const { i18n } = useTranslation();
  const [teamsContext, setTeamsContext] = useState<microsoftTeamsApp.Context>();
  const [hopexContext, setHopexContext] = useState<IHopexContext>();
  const [credentialsChecked, setCredentialsChecked] = useState<boolean>(false);

  useEffect(() => {
    if (!hopexContext) {
      try {
        setCredentialsChecked(true);
      }
      catch (e) {
      }
    }
  }, [hopexContext]);

  useEffect(() => {
      const initTeamsApp = async () => {
          try {
              await microsoftTeamsApp.initialize();
              const context = await microsoftTeamsApp.getContext();

              setTeamsContext(context);
              setThemeName(context.app.theme);
              i18n.changeLanguage(context.app.locale);

              microsoftTeamsApp.registerOnThemeChangeHandler(setThemeName);

              microsoftTeamsApp.notifyAppLoaded();
              microsoftTeamsApp.notifySuccess();
          } catch (error) {
              console.error("Erreur lors de l'initialisation de Teams : ", error);
              // notifyFailure peut être utile ici si tu veux plus de feedback
          }
      };

      if (!teamsContext) {
          initTeamsApp();
      }
  }, [teamsContext, i18n, setThemeName]);

  return (
    <div className={`App ${document.location.pathname === '/tabs/config' ? 'Config' : 'Tab'}`}>
      <AppContext.Provider
        value={{
          hopexContext,
          setHopexContext,
          teamsContext,
          setTeamsContext,
              }}>
        <Provider theme={theme}>
          {teamsContext && credentialsChecked && (
            <Router>
              <Switch>
                <Route path='/tabs/diagram'>
                  <DiagramRoute />
                </Route>
                <Route path="/tabs/config">
                  <ConfigurationRoute />
                </Route>
                <Route path="/redirect">
                  <RedirectRoute />
                </Route>
                <Route path="/login/end">
                  <LoginEndRoute />
                </Route>
              </Switch>
            </Router>
          )}
          {(!teamsContext || !credentialsChecked) && <Loader />}
        </Provider>
      </AppContext.Provider>
    </div>
  );
}

export default App;
